"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.palette = exports.PaletteColors = void 0;
var PaletteColors;
exports.PaletteColors = PaletteColors;

(function (PaletteColors) {
  PaletteColors["blue"] = "#2A6DB7";
  PaletteColors["navy"] = "#2A4372";
  PaletteColors["sky"] = "#E4EDF6";
  PaletteColors["charcoal"] = "#333333";
  PaletteColors["grey"] = "#666666";
  PaletteColors["stone"] = "#BBBBBB";
  PaletteColors["pebble"] = "#D6D6D6";
  PaletteColors["lightGrey"] = "#EEE";
  PaletteColors["green"] = "#4CB564";
  PaletteColors["greenDark"] = "#3F754C";
  PaletteColors["mintDark"] = "#65AA8C";
  PaletteColors["mintLight"] = "#BFE7D6";
  PaletteColors["mintMain"] = "#7DCFAC";
  PaletteColors["orange"] = "#F79533";
  PaletteColors["purple"] = "#673494";
  PaletteColors["red"] = "#B73535";
  PaletteColors["teal"] = "#5FADCF";
  PaletteColors["yellow"] = "#ECDA37";
  PaletteColors["greyBlue"] = "#F6F8FA";
  PaletteColors["lightBlueFocus"] = "#5DB0FF";
})(PaletteColors || (exports.PaletteColors = PaletteColors = {}));

var palette = {
  background: {
    default: PaletteColors.greyBlue
  },
  brand: {
    green: PaletteColors.green,
    grey: {
      charcoal: PaletteColors.charcoal,
      grey: PaletteColors.grey,
      lightGrey: PaletteColors.lightGrey,
      pebble: PaletteColors.pebble,
      stone: PaletteColors.stone
    },
    mint: {
      dark: PaletteColors.mintDark,
      light: PaletteColors.mintLight,
      main: PaletteColors.mintMain
    },
    orange: PaletteColors.orange,
    purple: PaletteColors.purple,
    red: PaletteColors.red,
    teal: PaletteColors.teal,
    yellow: PaletteColors.yellow
  },
  divider: PaletteColors.pebble,
  error: {
    main: PaletteColors.red
  },
  focusRing: {
    main: PaletteColors.lightBlueFocus
  },
  primary: {
    dark: PaletteColors.navy,
    light: PaletteColors.sky,
    main: PaletteColors.blue
  },
  success: {
    dark: PaletteColors.greenDark,
    main: PaletteColors.green
  },
  warning: {
    main: PaletteColors.orange
  }
};
exports.palette = palette;